import React from "react";

export type SitAtHomeProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 34,
    height: 34,
  },
  medium: {
    width: 34,
    height: 34,
  },
  large: {
    width: 34,
    height: 34,
  },
};

export const SitAtHome: JSX.Element & any = React.forwardRef<
  SVGSVGElement,
  SitAtHomeProps
>((props, ref) => {
  const { size = "medium", width, height, color = "#AE59C6" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];
  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.12313 0.580746C7.2738 0.473125 7.4762 0.473125 7.62687 0.580746L12.1417 3.8056L13.0083 4.42465L13.6935 4.91408C13.8074 4.99542 13.875 5.12675 13.875 5.2667V13.0667C13.875 13.306 13.681 13.5 13.4417 13.5H6.94167H2.60833H1.30833C1.06901 13.5 0.875 13.306 0.875 13.0667V5.2667C0.875 5.12675 0.942585 4.99542 1.05646 4.91408L7.12313 0.580746ZM4.34167 7.31426C4.34167 6.42275 5.0724 5.70004 5.97382 5.70004C6.40669 5.70004 6.82183 5.87011 7.12792 6.17284L7.375 6.4172L7.62208 6.17284C7.92817 5.87011 8.34331 5.70004 8.77618 5.70004C9.6776 5.70004 10.4083 6.42275 10.4083 7.31426C10.4083 7.74237 10.2364 8.15295 9.93029 8.45568L7.51799 10.8415C7.43902 10.9196 7.31098 10.9196 7.23201 10.8415L4.81971 8.45568C4.51362 8.15295 4.34167 7.74237 4.34167 7.31426Z"
        fill={color}
      />
    </svg>
  );
});

SitAtHome.displayName = "SitAtHome";
